export const rooms = [
  {
    id: 1,
    type: 'Duplo', // Alterado para refletir o tipo de quarto
    title: 'Quarto Duplo (Casal ou Twin)',
    accessible: true,
    description: 'Ideal para casais ou amigos, nosso Quarto Duplo oferece conforto e praticidade no coração da cidade, com opções de cama de casal ou duas de solteiro.',
    images: [
      '/images/AccommodationsSection/quarto_duplo001.webp',
      '/images/AccommodationsSection/quarto_duplo002.webp',
      '/images/AccommodationsSection/quarto_duplo003.webp',
      '/images/AccommodationsSection/quarto_duplo004.webp',
      '/images/AccommodationsSection/quarto_duplo005.webp'
    ],
    capacity: 'Até 2 pessoas',
    features: [
      { icon: 'FaBed', text: '1 cama de casal ou 2 de solteiro' },
      { icon: 'FaTv', text: 'TV LCD' },
      { icon: 'FaSnowflake', text: 'Ar condicionado' },
      { icon: 'FaWineBottle', text: 'Frigobar' },
      { icon: 'FaWifi', text: 'Wi-Fi gratuito' },
      { icon: 'FaShower', text: 'Banheiro privativo' },
      { icon: 'FaMugHot', text: 'Café da manhã incluso' },
    ]
  },
  {
    id: 2,
    type: 'Triplo', 
    title: 'Quarto Triplo',
    accessible: true,
    description: 'Perfeito para famílias pequenas ou grupos de amigos, este quarto oferece flexibilidade e conforto para até três hóspedes.',
    images: [
      '/images/AccommodationsSection/quarto_triplo001.webp',
      '/images/AccommodationsSection/quarto_triplo002.webp',
      '/images/AccommodationsSection/quarto_triplo003.webp'
    ],
    capacity: 'Até 3 pessoas',
    features: [
      { icon: 'FaBed', text: '1 cama de casal e 1 de solteiro' },
      { icon: 'FaTv', text: 'TV LCD' },
      { icon: 'FaSnowflake', text: 'Ar condicionado' },
      { icon: 'FaWineBottle', text: 'Frigobar' },
      { icon: 'FaWifi', text: 'Wi-Fi gratuito' },
      { icon: 'FaShower', text: 'Banheiro privativo' },
      { icon: 'FaMugHot', text: 'Café da manhã incluso' },
    ]
  },
  {
    id: 3,
    type: 'Quádruplo', 
    title: 'Quarto Quádruplo',
    accessible: true,
    description: 'Espaçoso e versátil, nosso quarto quádruplo é a solução ideal para famílias ou grupos maiores, garantindo o conforto de todos.',
    images: [
      '/images/AccommodationsSection/quarto_quadruplo001.webp',
      '/images/AccommodationsSection/quarto_quadruplo002.webp',
      '/images/AccommodationsSection/quarto_quadruplo003.webp',
      '/images/AccommodationsSection/quarto_quadruplo004.webp',
      '/images/AccommodationsSection/quarto_quadruplo005.webp'
    ],
    capacity: 'Até 4 pessoas',
    features: [
      { icon: 'FaBed', text: 'Variações com camas de casal e solteiro' },
      { icon: 'FaTv', text: 'TV LCD' },
      { icon: 'FaSnowflake', text: 'Ar condicionado' },
      { icon: 'FaWineBottle', text: 'Frigobar' },
      { icon: 'FaWifi', text: 'Wi-Fi gratuito' },
      { icon: 'FaShower', text: 'Banheiro privativo' },
      { icon: 'FaMugHot', text: 'Café da manhã incluso' },
    ]
  }
];